// src/components/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Román Valderrábano El Catador | Café de Especialidad en Xicotepec",
  description = "Desde 1880 produciendo café de especialidad en la Sierra Norte de Puebla. Tours, catación con Q Grader y cocina tradicional de humo en Xicotepec, Pueblo Mágico.",
  keywords = "café de especialidad, Xicotepec, Puebla, café mexicano, catador Q Grader, Román Valderrábano, café de altura, bosque mesófilo, café orgánico, tour cafetalero, cocina de humo, pueblo mágico",
  image = "https://romanvalderrabanoelcatador.com/static/media/logo.60086e5400cc0d106d61.jpg",
  url = "https://romanvalderrabanoelcatador.com/",
  type = "website",
  publishedTime,
  modifiedTime,
  author = "Román Valderrábano El Catador",
  section,
  tags = []
}) => {
  const siteTitle = "Román Valderrábano El Catador";
  const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;

  return (
    <Helmet>
      {/* Básico */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="es_MX" />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Artículo (si aplica) */}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {section && <meta property="article:section" content={section} />}
      {tags.map((tag, index) => (
        <meta key={index} property="article:tag" content={tag} />
      ))}
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="MX-PUE" />
      <meta name="geo.placename" content="Xicotepec de Juárez" />
      <meta name="geo.position" content="20.275843;-97.964414" />
      <meta name="ICBM" content="20.275843, -97.964414" />
    </Helmet>
  );
};

export default SEO;